import NewDiscussion from "./newDiscussion.component";

export default NewDiscussion;
